<template>
  <div class="home">
    <section class="hero">
      <div class="overlay"></div>
      <div class="hero-text container">
        <div class="tracking-container">
          <h2 class="tracking-title">Lacak Kiriman Anda</h2>
          <div class="tracking-card">
            <v-form>
              <v-text-field
                outlined
                v-model="awb"
                class="tracking-input text-center"
                single-line
                hide-details
                label="Masukan No Resi / No Referensi"
              >
                <template v-slot:prepend>
                  <v-icon color="primary">mdi-package-variant-closed</v-icon>
                </template>
              </v-text-field>
              <div class="tracking-actions">
                <v-btn
                  color="primary"
                  rounded
                  @click="HandleClick"
                  class="action-btn"
                >
                  <v-icon left>mdi-magnify</v-icon>
                  Lacak
                </v-btn>
                <v-btn color="error" rounded @click="Reset" class="action-btn">
                  <v-icon left>mdi-reload</v-icon>
                  Reset
                </v-btn>
              </div>
            </v-form>
            <!-- Loader -->
            <div v-if="isLoading" class="loader-container">
              <div class="loader"></div>
              <span class="loader-text">Mencari data...</span>
            </div>
            <!-- Results -->
            <div v-if="lacak === '1'" class="results-container">
              <v-card elevation="3" class="result-card">
                <v-card-title>
                  <h4>Status Kiriman</h4>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="2">
                      <v-text-field
                        label="No Resi / No Referensi"
                        v-model="noawb"
                        readonly=""
                        outlined=""
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        label="Status"
                        v-model="status"
                        readonly=""
                        outlined=""
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        label="Keterangan"
                        v-model="ket"
                        readonly=""
                        outlined=""
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        label="Tanggal"
                        v-model="tanggal"
                        readonly=""
                        outlined=""
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        label="Pengirim"
                        v-model="companyname"
                        readonly=""
                        outlined=""
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        label="Asal"
                        v-model="asal"
                        readonly=""
                        outlined=""
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        label="Tujuan"
                        v-model="tujuan"
                        readonly=""
                        outlined=""
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        label="Layanan"
                        v-model="layanan"
                        readonly=""
                        outlined=""
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field
                        label="Koli"
                        v-model="pieces"
                        readonly=""
                        outlined=""
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field
                        label="Kg"
                        v-model="weight"
                        readonly=""
                        outlined=""
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field
                        label="Vol"
                        v-model="vol"
                        readonly=""
                        outlined=""
                        hide-details
                      ></v-text-field>
                    </v-col>

                    <v-dialog v-model="showProofDialog" max-width="800">
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip
                          v-if="bukti"
                          color="green"
                          text-color="white"
                          v-bind="attrs"
                          v-on="on"
                          class="proof-chip"
                        >
                          Bukti
                        </v-chip>
                      </template>
                      <v-card>
                        <v-card-title
                          class="headline d-flex justify-space-between"
                        >
                          <span>Bukti Pengiriman</span>
                          <v-btn icon @click="showProofDialog = false">
                            <v-icon color="grey darken-1">mdi-close</v-icon>
                          </v-btn>
                        </v-card-title>
                        <v-card-text>
                          <v-img
                            :src="`https://api.bdpcargo.co.id/uploads/${bukti}`"
                            max-height="600"
                            contain
                            class="proof-image"
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="grey lighten-5"
                                ></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </v-row>
                </v-card-text>
              </v-card>
            </div>
            <!-- Not Found -->
            <div v-if="lacak === '2'" class="not-found-container">
              <v-card elevation="3" class="not-found-card">
                <v-card-title class="not-found-title">
                  <v-icon large color="error" class="mr-2"
                    >mdi-alert-circle</v-icon
                  >
                  <h4>Data Tidak Ditemukan</h4>
                </v-card-title>
              </v-card>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="customers-section">
      <div class="container">
        <h2 class="section-title">Pelanggan Kami</h2>
        <v-row justify="center" align="center">
          <v-col
            cols="6"
            sm="4"
            md="3"
            lg="2"
            v-for="(customer, index) in customers"
            :key="index"
          >
            <v-img
              :src="customer.logo"
              :alt="customer.name"
              contain
              height="80"
              class="customer-logo"
            ></v-img>
          </v-col>
        </v-row>
      </div>
    </section>

    <div>
      <a :href="whatsappLink" class="whatsapp-button">
        <i class="fab fa-whatsapp"></i> Hubungi Kami di WhatsApp
      </a>
    </div>
    <footer class="footer">
      <div class="container">
        <v-row>
          <v-col cols="12" sm="4">
            <div class="footer-section">
              <h3 class="footer-title">PT. BATHI DUA PUTRA</h3>
              <p class="footer-text">
                Komitmen untuk memberikan pelayanan terbaik tepat dan dapat
                diandalkan bagi pelanggan
              </p>
              <div class="certification-info">
                <h4 class="cert-title">ISO 9001:2015 Certified</h4>
                <p class="cert-details">
                  Quality Management System<br />
                  Certificate No: QM-BDP07022250665<br />
                  EA Sector: 31, 34<br />
                  Provision of Services Such as: Courier Service
                </p>
                <div class="cert-badges">
                  <v-img
                    src="@/assets/certification/iso_9001-2015.jpeg"
                    height="40"
                    contain
                    class="cert-badge"
                  />
                  <v-img
                    src="@/assets/certification/ina.jpeg"
                    height="40"
                    contain
                    class="cert-badge"
                  />
                </div>
              </div>
            </div>
          </v-col>

          <v-col cols="12" sm="4">
            <div class="footer-section">
              <h3 class="footer-title">Kontak</h3>
              <div class="contact-info">
                <div class="contact-item">
                  <v-icon color="grey lighten-1" small>mdi-phone</v-icon>
                  <span>+62 896-5436-7407</span>
                </div>
                <div class="contact-item">
                  <v-icon color="grey lighten-1" small>mdi-email</v-icon>
                  <span>info@bdpcargo.co.id</span>
                </div>
                <div class="contact-item">
                  <v-icon color="grey lighten-1" small>mdi-map-marker</v-icon>
                  <span>Jakarta, Indonesia</span>
                </div>
              </div>
            </div>
          </v-col>

          <v-col cols="12" sm="4">
            <div class="footer-section">
              <h3 class="footer-title">Jam Operasional</h3>
              <div class="operation-hours">
                <div class="hour-item">
                  <span class="day">Senin - Jumat:</span>
                  <span>08:00 - 17:00</span>
                </div>
                <div class="hour-item">
                  <span class="day">Sabtu:</span>
                  <span>09:00 - 14:00</span>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>

        <div class="footer-bottom">
          <div class="copyright">
            © {{ new Date().getFullYear() }} birin243. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "HomeView",
  data() {
    return {
      isLoading: false,
      lacak: "0",
      awb: "",
      items: [],
      dialogLacak: false,
      showProofDialog: false,
      status: "",
      noawb: "",
      ket: "",
      asal: "",
      tujuan: "",
      layanan: "",
      companyname: "",
      bukti: "",
      whatsappLink:
        "https://api.whatsapp.com/send?phone=6289654367407&text=*Hai%20Admin%20Saya%20mau%20tanya%20tentang%20pengiriman%20barang%20nih%2C%20Saya%20dapat%20wa%20nya%20dari%20Web%20nya%20bdpcargo.co.id%20Terima%20kasih*",
      customers: [
        {
          name: "MKP",
          logo: require("@/assets/customers/mkp.png"),
        },
        {
          name: "Baradinamika",
          logo: require("@/assets/customers/baradinamika.png"),
        },
        {
          name: "Petrosea",
          logo: require("@/assets/customers/petrosea.jpeg"),
        },
        {
          name: "Pupuk Kaltim",
          logo: require("@/assets/customers/pupuk-kaltim.png"),
        },
        {
          name: "Atlas Copco",
          logo: require("@/assets/customers/atlas-copco.jpeg"),
        },
        {
          name: "Astragraphia",
          logo: require("@/assets/customers/astragraphia.png"),
        },
        {
          name: "Eastsyar",
          logo: require("@/assets/customers/eastsyar.png"),
        },
        {
          name: "Trans NDN",
          logo: require("@/assets/customers/transkons.png"),
        },
        {
          name: "Epson",
          logo: require("@/assets/customers/epson.png"),
        },
        {
          name: "Chitra Paratama",
          logo: require("@/assets/customers/chitra-paratama.png"),
        },
        {
          name: "Nutricell",
          logo: require("@/assets/customers/nutricell.png"),
        },
        {
          name: "Chakra Jawara",
          logo: require("@/assets/customers/chakra-jawara.png"),
        },
        {
          name: "United Tractors",
          logo: require("@/assets/customers/united-tractors.png"),
        },
      ],
    };
  },

  methods: {
    async Reset() {
      this.lacak = "0";
      this.awb = "";
    },
    async HandleClick() {
      this.isLoading = true; // Mengaktifkan loader
      try {
        const headers = {
          "Content-Type": "application/x-www-form-urlencoded",
        };
        const response = await axios.post(
          "https://bdpcargo.co.id/api/lacak.php",
          {
            awb: this.awb,
          },
          { headers }
        );
        this.response = response.data;
        console.log(response.data.data);

        if (response.data.status === "fail") {
          this.items = [];
          this.lacak = "2";
          this.isLoading = false; // Menonaktifkan loader
        } else {
          this.noawb = response.data.data.noawb;
          this.status = response.data.data.status;
          this.ket = response.data.data.ket;
          this.status = response.data.data.status;
          this.asal = response.data.data.asal;
          this.tujuan = response.data.data.tujuan;
          this.service = response.data.data.service;
          this.vol = response.data.data.vol;
          this.weight = response.data.data.weight;
          this.pieces = response.data.data.pieces;
          this.tanggal = response.data.data.tgl;
          this.layanan = response.data.data.service;
          this.companyname = response.data.data.companyname;
          this.bukti = response.data.data.upload;
          this.lacak = "1";
          this.items = response.data.data;
          this.isLoading = false; // Menonaktifkan loader
          //localStorage.setItem("authenticated",true)
          //this.$router.push('/home')
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.hero {
  background-image: url("../assets/h1_hero_.jpg");
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  position: relative;
  height: 90vh; // Change from 100vh to 80vh
  min-height: 600px; // Add minimum height for smaller screens
  display: flex;
  align-items: center;

  @media (max-width: 600px) {
    height: 90vh; // Slightly taller on mobile
    min-height: 500px;
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1;
  }

  .hero-text {
    position: relative;
    z-index: 2;
    width: 100%;
  }

  .tracking-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
  }

  .tracking-title {
    color: #fff;
    font-size: 3rem;
    font-weight: 700;
    text-align: center;
    margin-bottom: 2rem;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  }

  .tracking-card {
    background: rgba(255, 255, 255, 0.95);
    border-radius: 15px;
    padding: 2rem;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(10px);
  }

  .tracking-input {
    .v-input__slot {
      background: white !important;
    }

    :deep(.v-text-field__slot input) {
      text-align: center !important;
    }

    :deep(.v-label) {
      width: 100%;
      text-align: center;
      left: 0 !important;
      right: 0 !important;
      transform-origin: center top !important;
    }

    &.v-text-field--outlined.v-input--is-focused .v-label,
    &.v-text-field--outlined.v-input--has-state .v-label {
      transform: translateY(-20px) scale(0.75);
    }
  }

  .tracking-actions {
    display: flex;
    gap: 1rem;
    margin-top: 1.5rem;
    justify-content: center;
  }

  .action-btn {
    min-width: 120px;
    height: 45px;
    font-size: 1rem;
    text-transform: none;
    letter-spacing: 0.5px;

    &.v-btn--rounded {
      border-radius: 25px;
    }
  }

  .loader-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 2rem 0;

    .loader-text {
      margin-top: 1rem;
      color: #666;
    }
  }

  .results-container,
  .not-found-container {
    margin-top: 2rem;
  }

  .result-card,
  .not-found-card {
    background: white;
    border-radius: 10px;
    overflow: hidden;
  }

  .not-found-title {
    color: #ff5252;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 600px) {
    .tracking-title {
      font-size: 2rem;
    }

    .tracking-actions {
      flex-direction: column;

      .action-btn {
        width: 100%;
      }
    }
  }
}
.customers-section {
  padding: 80px 0;
  background-color: #fff;

  .section-title {
    text-align: center;
    font-size: 36px;
    color: #333;
    margin-bottom: 50px;
    font-weight: 600;
  }

  .customer-logo {
    transition: transform 0.3s ease;
    filter: grayscale(100%);
    opacity: 0.7;
    padding: 15px;

    &:hover {
      transform: scale(1.05);
      filter: grayscale(0%);
      opacity: 1;
    }
  }
}
.whatsapp-button {
  background-color: #25d366; /* Warna latar belakang WhatsApp */
  color: #fff; /* Warna teks */
  display: inline-block;
  padding: 10px 20px;
  border-radius: 30px; /* Untuk membuat tombol berbentuk bulat */
  text-decoration: none;
  position: fixed;
  bottom: 20px;
  right: 20px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2); /* Efek bayangan */
  z-index: 1000; /* Pastikan tombol berada di atas elemen lain */
}

.whatsapp-button i {
  margin-right: 10px; /* Jarak antara ikon dan teks */
}

.proof-chip {
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }
}

.proof-image {
  border-radius: 4px;
  overflow: hidden;
}

.headline {
  padding: 16px 24px;
  border-bottom: 1px solid #e0e0e0;
}
.close-btn {
  transition: all 0.2s ease;

  &:hover {
    background-color: #f5f5f5;
    transform: rotate(90deg);
  }

  .v-icon {
    font-size: 20px;
  }
}

.footer {
  background-color: #1a1a1a;
  color: #ffffff;
  padding: 60px 0 20px;
  margin-top: 60px;
}

.footer-section {
  margin-bottom: 30px;
}

.footer-title {
  color: #ffffff;
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 10px;

  &:after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 40px;
    height: 2px;
    background-color: #4caf50;
  }
}

.footer-text {
  color: #9e9e9e;
  line-height: 1.6;
}

.contact-info {
  .contact-item {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    color: #9e9e9e;

    .v-icon {
      margin-right: 10px;
    }
  }
}

.operation-hours {
  .hour-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    color: #9e9e9e;

    .day {
      font-weight: 500;
    }
  }
}

.footer-bottom {
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;

  .copyright {
    color: #757575;
    font-size: 0.9rem;
  }
}

@media (max-width: 600px) {
  .footer {
    padding: 40px 0 20px;
  }

  .footer-section {
    text-align: center;

    .footer-title:after {
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .contact-info .contact-item {
    justify-content: center;
  }

  .operation-hours .hour-item {
    flex-direction: column;
    align-items: center;
    gap: 5px;
  }
}

.certification-info {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);

  .cert-title {
    color: #4caf50;
    font-size: 1.1rem;
    font-weight: 600;
    margin-bottom: 10px;
  }

  .cert-details {
    color: #9e9e9e;
    font-size: 0.9rem;
    line-height: 1.6;
    margin-bottom: 15px;
  }

  .cert-badges {
    display: flex;
    gap: 5px;
    align-items: center;

    .cert-badge {
      filter: grayscale(0.3);
      transition: filter 0.3s ease;

      &:hover {
        filter: grayscale(0);
      }
    }
  }
}

@media (max-width: 600px) {
  .certification-info {
    text-align: center;

    .cert-badges {
      justify-content: center;
    }
  }
}
</style>